exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".connect-admin.pz_modal.sm > .modal_content > .modal-body {\n  padding: 0px 24px 16px 24px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n.modal-body {\n  padding-bottom: 16px;\n}\n", ""]);

